import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "@/components/site/NavBar";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import CallFab from "@/components/site/CallFab";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-brand-bg">
      <NavBar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <CallFab />
    </div>
  );
}
